var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"layout-header",attrs:{"height":_vm.setHeaderHeight}},[_c('NavBarsIndex')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }